import React from "react";
import Reports from "./Reports";

const OperationReport = () => <Reports reportType="operation" />;

export default OperationReport;
